// extracted by mini-css-extract-plugin
export var authorBox = "author-page-module--author-box--YLlyd";